import mutationsTypes from '@/store/mutationTypes'
import axios from 'axios'
import api from '@/config/api'
import apiMock from '@/config/apiMock'
import getCsrfToken from '@/store/Csrf'
import { commonUtil, countryUtil, countryCallingCodeUtil } from '@/util'
import requestSupplierRegister from './request/registerSupplier'
import requestSuggestedRecievingLocationRegister from './request/registerSuggestedRecievingLocation'
import requestSuggestedRecievingLocationEdit from './request/editSuggestedRecievingLocation'

import property from './property'
import { i18n } from '@/main.js'

const Actions = {
  // SP01 仕入先一覧取得
  getSuppliersFromApi: async (
    { state, dispatch, commit, getters, rootGetters, rootState },
    params
  ) => {
    return await axios
      // .get(apiMock.SUPPLIER_LIST, params)
      .get(api.SUPPLIER_LIST, { params: params })
      .then((response) => {
        const supplierList = response.data.data.supplierList
        // マスタ画面一覧ソート用の値を追加
        supplierList.forEach((supplier) => {
          // 希望入庫場所
          const suggestedReceivingLocation =
            state.suggestedReceivingLocationList.find(
              (element) =>
                element.suggestedReceivingLocationId ===
                supplier.suggestedReceivingLocationId
            )
          if (suggestedReceivingLocation) {
            supplier.suggestedReceivingLocation =
              suggestedReceivingLocation.location
          } else {
            supplier.suggestedReceivingLocation = '-'
          }

          // 連絡先
          const phoneNumber = countryCallingCodeUtil.formatPhoneNumber(
            supplier.phoneNumber,
            supplier.phoneNumberCountryId
          )
          const faxNumber = countryCallingCodeUtil.formatPhoneNumber(
            supplier.faxNumber,
            supplier.faxNumberCountryId
          )
          const displayPhoneNumber = phoneNumber ? 'TEL:' + phoneNumber : ''
          const displayFaxNumber = faxNumber ? 'FAX:' + faxNumber : ''
          const email = supplier.email ? 'Email:' + supplier.email : ''
          supplier.contactInfo =
            displayPhoneNumber + displayFaxNumber + email || '-'

          // 住所
          const postcode = commonUtil.formatPostalCode(
            supplier.postalCode,
            supplier.addressCountryId
          )
          const regionName = countryUtil.getRegionInfo(
            supplier.addressCountryId,
            supplier.regionId
          ).label
          const displayPostcode = postcode ? '〒' + postcode : ''
          supplier.addressInfo =
            displayPostcode +
              (regionName || '') +
              (supplier.address1 || '') +
              (supplier.address2 || '') || '-'
        })

        const path = mutationsTypes.SUPPLIER_SET_SUPPLIERS
        commit(path, { supplierList })

        // TODO テスト用
        // console.log(
        //   '仕入先一覧取得 response.data.data : ' +
        //     JSON.stringify(response.data.data)
        // )

        const getData = getters.getSuppliersFromState
        const ret = commonUtil.afterApiSuccessProcess(response, getData)
        return ret
      })
      .catch((error) => {
        // commonErrorControl(error.response)
        // TODO: APIエラー時共通処理
        commonUtil.afterApiFailProcess(error.response)
        return false
      })
  },
  // SP02 仕入先登録
  registerSupplier: async (
    { state, dispatch, commit, getters, rootGetters, rootState },
    params
  ) => {
    await getCsrfToken()
    const req = requestSupplierRegister.request.createRequest(params)

    return await axios
      // .get(apiMock.SUPPLIER_REGISTER_EDIT)
      .post(api.SUPPLIER_REGISTER_EDIT, req)
      .then((response) => {
        return true
      })
      .catch((error) => {
        // commonErrorControl(error.response)
        commonUtil.afterApiFailProcess(error.response)
        return false
      })
  },
  // SP03 仕入先編集
  editSupplier: async (
    { state, dispatch, commit, getters, rootGetters, rootState },
    { supplierId, params }
  ) => {
    await getCsrfToken()
    const req = requestSupplierRegister.request.createRequest(params)

    return await axios
      // .get(apiMock.SUPPLIER_REGISTER_EDIT)
      .patch(`${api.SUPPLIER_REGISTER_EDIT}/${supplierId}`, req)
      .then((response) => {
        return true
      })
      .catch((error) => {
        // commonErrorControl(error.response)
        commonUtil.afterApiFailProcess(error.response)

        return false
      })
  },
  // WLL01 希望入庫場所一覧取得
  getSuggestedReceivingLocationListFromApi: async ({
    state,
    dispatch,
    commit,
    getters,
    rootGetters,
    rootState
  }) => {
    return await axios
      // .get(apiMock.SUGGESTED_RECEIVING_LOCATION_LIST)
      .get(api.SUGGESTED_RECEIVING_LOCATION_LIST)
      .then((response) => {
        const suggestedReceivingLocationList =
          response.data.data.suggestedReceivingLocationList
        // マスタ画面一覧ソート用の値を追加
        suggestedReceivingLocationList.forEach((location) => {
          const postcode = commonUtil.formatPostalCode(
            location.postalCode,
            location.addressCountryId
          )
          const regionName = countryUtil.getRegionInfo(
            location.addressCountryId,
            location.regionId
          ).label

          if (
            postcode ||
            regionName ||
            location.address1 ||
            location.address2
          ) {
            location.address =
              (postcode ? '〒' + postcode : '') +
              (regionName || '') +
              (location.address1 || '') +
              (location.address2 || '')
          } else {
            location.address = '-'
          }
        })
        const path =
          mutationsTypes.SUPPLIER_SET_SUGGESTED_RECIEVING_LOCATION_LIST
        commit(path, { suggestedReceivingLocationList })
        const getData = getters.getSuggestedReceivingLocationListFromState
        const ret = commonUtil.afterApiSuccessProcess(response, getData)
        return ret
      })
      .catch((error) => {
        // commonErrorControl(error.response)
        commonUtil.afterApiFailProcess(error.response)
        return false
      })
  },
  // WLL02 希望入庫場所登録
  registerSuggestedReceivingLocation: async (
    { state, dispatch, commit, getters, rootGetters, rootState },
    params
  ) => {
    await getCsrfToken()
    const req =
      requestSuggestedRecievingLocationRegister.request.createRequest(params)

    return await axios
      // .get(apiMock.SUGGESTED_RECEIVING_LOCATION_REGISTER_EDIT)
      .post(api.SUGGESTED_RECEIVING_LOCATION_REGISTER_EDIT, req)
      .then((response) => {
        return true
      })
      .catch((error) => {
        // commonErrorControl(error.response)
        commonUtil.afterApiFailProcess(error.response)
        return false
      })
  },
  // WLL03 希望入庫場所編集
  editSuggestedReceivingLocation: async (
    { state, dispatch, commit, getters, rootGetters, rootState },
    params
  ) => {
    await getCsrfToken()
    const req =
      requestSuggestedRecievingLocationEdit.request.createRequest(params)

    return await axios
      // .get(apiMock.SUGGESTED_RECEIVING_LOCATION_REGISTER_EDIT)
      .patch(
        `${api.SUGGESTED_RECEIVING_LOCATION_REGISTER_EDIT}/${params.id}`,
        req
      )
      .then((response) => {
        return true
      })
      .catch((error) => {
        // commonErrorControl(error.response)
        commonUtil.afterApiFailProcess(error.response)
        return false
      })
  },
  // WLL04 希望入庫場所削除
  deleteSuggestedReceivingLocation: async (
    { state, dispatch, commit, getters, rootGetters, rootState },
    params
  ) => {
    await getCsrfToken()

    return await axios
      .patch(`${api.SUGGESTED_RECEIVING_LOCATION_DELETE}/${params.id}`)
      .then((response) => {
        return true
      })
      .catch((error) => {
        commonUtil.afterApiFailProcess(error.response)
        return false
      })
  },
  // CU04 顧客CSVアップロード
  fileUpload: async (
    { state, dispatch, commit, getters, rootGetters, rootState },
    file
  ) => {
    const instance = axios.create({
      headers: { 'Content-Type': 'multipart/form-data' }
    })
    await getCsrfToken()
    return await instance
      // .get(apiMock.FILE_UPLOAD)
      .post(api.SUPPLIER_CSV_UPLOAD, file)
      .then((response) => {
        const ret = commonUtil.afterApiSuccessProcess(
          response,
          response.data.data
        )
        return ret
      })
      .catch((error) => {
        if (error.response.data.data && error.response.data.data.errorList) {
          const errors = []
          error.response.data.data.errorList.forEach((ele) => {
            for (const index in ele.errors) {
              ele.errors[index].flat().forEach((error) => {
                const errorMsg =
                  i18n.locale === 'cn'
                    ? `第${ele.lineNumber}行 ${error}`
                    : `${ele.lineNumber}行目 ${error}`
                errors.push(errorMsg)
              })
            }
          })

          alert(`${errors.join('\n')}`)
          return false
        }
        // commonErrorControl(error.response)
        commonUtil.afterApiFailProcess(error.response)
        return false
      })
  }
}

export default Actions
